// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"MP-z","categoryName":"NP-z","categoryNameSearchHeader":"OP-z","categoryContent":"PP-z","bottomAligned":"QP-z","image":"RP-z","imageNoBackground":"SP-z"};